'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';

import type { Reference } from '@eliadmin/core/src/api/references/references-types';

import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { HtmlDescription } from './shared/html-description';

export const ReferenceSwiper = ({ references }: { references: Reference[] }) => {
  return (
    <Swiper
      navigation={true}
      pagination={true}
      modules={[Navigation, Pagination]}
      className={cn('w-full', 'mySwiper', 'ea-blog-swiper !pb-8 sm:!pb-0')}
      spaceBetween={12}
      slidesPerView={'auto'}
      breakpoints={{
        1024: {
          spaceBetween: 24,
        },
        768: {
          spaceBetween: 16,
        },
      }}
    >
      {references.map(reference => (
        <SwiperSlide key={reference.name} className={cn('w-full max-w-[320px] sm:max-w-[405px]')}>
          <div
            className={cn(
              'flex w-full flex-col items-start justify-start gap-4 rounded-lg bg-white p-6',
            )}
          >
            <div className="flex w-full items-start justify-between">
              <div className="flex flex-col items-start justify-start gap-2">
                <h3 className="text-base font-bold text-foreground">{reference.name}</h3>
                {reference.name.startsWith('[MOCK]') && (
                  <p className="text-base font-normal text-muted-foreground">Ukážková referencia</p>
                )}
              </div>
              {!reference.name.startsWith('[MOCK]') && (
                <Image src={'/images/google.svg'} alt="Google" width={32} height={32} />
              )}
            </div>
            <HtmlDescription
              color="foreground"
              content={reference.description}
              size="sm"
              className="line-clamp-5 h-[104px] w-full"
            />
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};
